import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';

const Inicio = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '80vh', // Ocupa la altura completa de la ventana
        backgroundImage: `linear-gradient(rgba(3,116,206, 0.6), rgba(3,116,206, 0.6)), url(${process.env.PUBLIC_URL + '/whoweare.jpg'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Container
        sx={{
          height: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: 'white' // Para que el texto resalte sobre el fondo
        }}
      >
        <Typography variant="h3" component="h1" gutterBottom sx={{fontWeight: 'bold'}}>
          Promoting Your Brand In Europe
        </Typography>
        <Typography variant="h5" sx={{fontWeight: 'bold', width: '80%'}}>
          Strategy, Sales And Growth For Manufactures
        </Typography>
        <Button variant="outlined" component="a" href="#success-stories" 
            sx={{ 
                mt: 2, 
                borderColor: 'white', 
                color:'white', 
                width:'13rem', 
                height:'4rem', 
                fontWeight:'bold',
                borderWidth: '2px',
                fontSize: '1rem'
            }}>
            Success Stories
        </Button>
      </Container>

    </Box>
  );
};

export default Inicio;
